module.exports = __webpack_public_path__ + "media/paliwa/electricity@2x-d2544e88.png";